'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { capitalize } from '@root/utility'

import Layout from '@Layout/BackOffice'

let app = window.app;

export default class CustomQuoteText extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			id: ++app.form_index
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;
	}

	handleChange (e)
	{
		const component = this, props = this.props;

		let data =
		{
			value: e.target.value,
			name: e.target.name
		};

		if (props.onChange instanceof Function)
		{
			props.onChange(e, data);
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const element = props.element, status = props.status || { };

		let value = '', info, warning, error;

		let class_name = 'c-custom-quote-element c-custom-quote-element--text';

		if (props.data)
		{
			if (!props.id || parseInt(props.id) == props.id)
			{
				value = props.data['custom_quote[' + state.id + ']'];
			}
			else
			{
				value = props.data['custom_quote[' + props.id + ']'];
			}
		}

		if (status.info)
		{
			info =
			(
				<div className="c-form-label c-form-label--info">
					{ status.info }
				</div>
			);

			class_name += ' c-form-element--info';
		}

		if (status.warning)
		{
			warning =
			(
				<div className="c-form-label c-form-label--warning">
					{ status.warning }
				</div>
			);

			class_name += ' c-form-element--warning';
		}

		if (status.error)
		{
			error =
			(
				<div className="c-form-label c-form-label--error">
					{ status.error }
				</div>
			);

			class_name += ' c-form-element--error';
		}

		var output =
		(
			<div className={ class_name }>
				<label htmlFor={ state.id } className="c-custom-quote-element__label">
					{
						element.label +
						([true, 'true'].includes(element.required) ? ' *' : '')
					}
				</label>

				{ warning }

				{ error }

				{ info }

				<input className="c-custom-quote-element__input"
					type={ element.type || 'text' } id={ state.id } value={ value }
					onChange={ component.handleChange } readOnly={ !props.editable }
					name={ 'custom_quote[' + element.id + ']' } />
			</div>
		);

		return output;
	}
}